<div class="flex flex-col gap-2 items-center text-on-surface dark:text-on-surface-darkmode">
  <div
    class="border border-outline dark:border-outline-darkmode rounded-lg p-2 text-primary dark:text-primary-darkmode"
  >
    <ng-icon name="heroNumberedList" size="32" class="!block" />
  </div>
  <h2 class="font-semibold text-lg">
    {{ 'cockpit.parseRequests.requiredDocumentsDialog.title' | transloco }}
  </h2>
</div>
<div class="py-4 flex flex-col gap-4 text-on-surface dark:text-on-surface-darkmode">
  <p
    class="text-sm"
    [innerHTML]="'cockpit.parseRequests.requiredDocumentsDialog.importantNotice' | transloco"
  ></p>
  <ul class="text-sm flex flex-col gap-2">
    <li class="flex gap-1.5 items-center">
      <ng-icon name="heroDocumentText" size="20" class="!block" />
      {{ 'cockpit.parseRequests.requiredDocumentsDialog.contractDocuments' | transloco }}
    </li>
    <li class="flex gap-1.5 items-center">
      <ng-icon name="heroDocumentCurrencyEuro" size="20" class="!block" />
      {{ 'cockpit.parseRequests.requiredDocumentsDialog.invoices' | transloco }}
    </li>
    <li class="flex gap-1.5 items-center">
      <ng-icon name="heroDocumentChartBar" size="20" class="!block" />
      {{ 'cockpit.parseRequests.requiredDocumentsDialog.consumptionInfo' | transloco }}
    </li>
    <li class="flex gap-1.5 items-center">
      <ng-icon name="heroDocumentArrowUp" size="20" class="!block" />
      {{ 'cockpit.parseRequests.requiredDocumentsDialog.priceSchedules' | transloco }}
    </li>
    <li class="flex gap-1.5 items-center">
      <ng-icon name="heroDocument" size="20" class="!block" />
      {{ 'cockpit.parseRequests.requiredDocumentsDialog.supplementaryTerms' | transloco }}
    </li>
  </ul>
  <p class="text-sm text-on-surface-variant dark:text-on-surface-variant-darkmode">
    <b>{{ 'cockpit.parseRequests.requiredDocumentsDialog.helpTitle' | transloco }}</b>
    {{ 'cockpit.parseRequests.requiredDocumentsDialog.helpDescription' | transloco }}
    <a
      [href]="'/organizations/' + organizationId() + '/dashboard?showContactDialog=true'"
      target="_blank"
      class="text-primary dark:text-primary-darkmode underline cursor-pointer"
      >{{ 'cockpit.parseRequests.requiredDocumentsDialog.helpContactLink' | transloco }}</a
    >
    {{ 'cockpit.parseRequests.requiredDocumentsDialog.helpContactSuffix' | transloco }}
  </p>
</div>
<ui-button expand="full" (click)="closeDialog.emit()">
  {{ 'cockpit.parseRequests.requiredDocumentsDialog.confirmButton' | transloco }}
</ui-button>
